import React, { useState } from "react";
import "./edit-shift-modal.css";
import "../../shared/styles/shared-styles.css";
import EditTime from './EditTime';

const EditShiftModal = (props) => {
  const {
    onCancel,
    endTime: defaultEndTime,
    startTime: defaultStartTime,
    onSaveChanges,
  } = props.staticProps;
  const {
    onChange,
    fieldsEdited,
    timeValidationError,
  } = props;
  const [endTime, setEndTime] = useState(defaultEndTime);
  const [startTime, setStartTime] = useState(defaultStartTime);
  return (
    <div className="edit-shift-modal">
      <div className="header-container">
        <h2>Edit shift</h2>
        <div onClick={onCancel} className="close-button">
          <img src={"images/roster/close-icon.svg"} className="close-icon"></img>
        </div>
      </div>
      <div>
        <EditTime
          startTime={startTime}
          endTime={endTime}
          onChange={onChange}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          timeValidationError={timeValidationError}
        />

        <div className="edit-shift-save-container">
          <button
            disabled={!fieldsEdited || timeValidationError}
            className={`modal-button modal-confirm-button ${(!fieldsEdited || timeValidationError) && 'save-button-disabled'}`}
            onClick={onSaveChanges}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditShiftModal;
